export type PspCode =
    | 'pep'
    | 'sep'
    | 'pna'
    | 'pec'
    | 'sadad'
    | 'fcp'
    | 'sepehr'
    | 'ikc'
    | 'bpm'
    | 'ecd'
    | 'asan';

type PspDefinition = {
    code: PspCode;
    label: string;
    color: string;
};

export const PSP_DEFINITIONS: readonly PspDefinition[] = [
    { code: 'pep', label: 'پرداخت الکترونیک پاسارگاد', color: '#ffc107' },
    { code: 'sep', label: 'پرداخت الکترونیک سامان', color: '#3083ff' },
    { code: 'pna', label: 'پرداخت نوین آرین', color: '#6a2480' },
    { code: 'pec', label: 'تجارت الکترونیک پارسیان', color: '#14387f' },
    { code: 'sadad', label: 'پرداخت الکترونیک سداد', color: '#f59602' },
    { code: 'fcp', label: 'فن آوا کارت', color: '#292f8d' },
    { code: 'sepehr', label: 'پرداخت الکترونیک سپهر', color: '#c8aa2d' },
    { code: 'ikc', label: 'کارت اعتباری ایران کیش', color: '#d0103a' },
    { code: 'bpm', label: 'به پرداخت ملت', color: '#ed1e28' },
    { code: 'ecd', label: 'الکترونیک کارت دماوند', color: '#32368f' },
    { code: 'asan', label: 'آسان پرداخت پرشین', color: '#e34521' },
] as const;

const aliases: Record<string, PspCode> = {
    irankish: 'ikc',
    asanpardakht: 'asan',
    sepher: 'sepehr',
};

const labels = PSP_DEFINITIONS.reduce<Record<string, string>>(
    (result, item) => {
        result[item.code] = item.label;
        return result;
    },
    {},
);

export const pspLabel: Record<string, string> = labels;

const colors = PSP_DEFINITIONS.reduce<Record<string, string>>(
    (result, item) => {
        result[item.code] = item.color;
        return result;
    },
    {},
);

export const normalizePspCode = (
    value?: string | null,
): PspCode | string | undefined => {
    const normalized = value?.trim().toLowerCase();
    if (!normalized) return undefined;

    return aliases[normalized] ?? normalized;
};

export const getPspLabel = (value?: string | null): string => {
    const code = normalizePspCode(value);
    if (!code) return '';

    return labels[code] ?? value?.trim() ?? '';
};

export const getPspColor = (value?: string | null): string | undefined => {
    const code = normalizePspCode(value);
    if (!code) return undefined;

    return colors[code];
};

export const getPspDisplayName = (value?: string | null): string => {
    const code = normalizePspCode(value);
    const label = getPspLabel(value);

    if (!code || !label) return '';

    return `${label} (${code.toUpperCase()})`;
};

const logoAssets: Record<PspCode, string> = {
    pep: 'pep',
    sep: 'sep',
    pna: 'pna',
    pec: 'pec',
    sadad: 'sadad',
    fcp: 'fcp',
    sepehr: 'sepehr',
    ikc: 'ikc',
    bpm: 'bpm',
    ecd: 'ecd',
    asan: 'asan',
};

export const getPspLogoAsset = (value?: string | null): string | undefined => {
    const code = normalizePspCode(value);
    if (!code) return undefined;

    return logoAssets[code as PspCode];
};
